class AddToCart {
  constructor() {
    this.sizeButtons = document.querySelectorAll(".js-size-btn");
    this.sizeSelects = document.querySelectorAll(".js-size-select");
    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");

    this.sections = [
      {
        section: "cart-drawer",
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        section: "cart-icon-bubble",
        id: "cart-icon-bubble",
      },
    ];

    this.init();
  }

  init() {
    this.sizeButtons.forEach((button) => {
      button.removeEventListener("click", this.handleSizeButtonClick.bind(this));
      button.addEventListener("click", this.handleSizeButtonClick.bind(this));
    });

    this.sizeSelects.forEach((select) => {
      select.removeEventListener("change", this.handleSizeSelectChange.bind(this));
      select.addEventListener("change", this.handleSizeSelectChange.bind(this));
    });
  }

  handleSizeButtonClick(event) {
    event.preventDefault();
    const button = event.currentTarget;

    if (button.classList.contains("is-sold-out")) return;

    const formData = {
      items: [
        {
          id: button.dataset.variantId,
          quantity: 1,
        },
      ],
      sections: this.sections.map((section) => section.section),
    };

    this.sendAddToCartRequest(formData);
  }

  handleSizeSelectChange(event) {
    const select = event.currentTarget;
    const selectedValue = select.value;

    if (!selectedValue) return;

    const variantData = JSON.parse(selectedValue);
    const formData = {
      items: [
        {
          id: variantData.id,
          quantity: 1,
        },
      ],
      sections: this.sections.map((section) => section.section),
    };

    this.sendAddToCartRequest(formData);
  }

  sendAddToCartRequest(formData) {
    fetch(Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        setTimeout(() => {
          this.cart.renderContents(response);
          this.gwpElement = document.getElementById("splide__gwp");
          if (this.gwpElement) {
            new Splide(this.gwpElement, {
              type: "loop",
              lazyLoad: false,
              arrows: true,
              perPage: 2.8,
              perMove: 1,
              gap: 16,
              pagination: false,
              clones: 6,
            }).mount();
          }
          document.dispatchEvent(new CustomEvent('countdown:restart')); 
          document.dispatchEvent(new CustomEvent('mini-countdown:restart')); 
          nostojs(api => { api.loadRecommendations()});
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

window.addEventListener("load", () => {
  setTimeout(() => new AddToCart(), 2000);
});
